export const FaqItems = (() => {
	'use strict';

	const init = () => {
		toggleCollapeable();
	}

	const toggleCollapeable = () => {
		document.querySelectorAll('.btn').forEach(item => {
			item.addEventListener('click', event => {
				let tab = document.querySelector(item.dataset.target);
				tab.parentElement.classList.toggle('active');
				tab.classList.toggle('collapsed')
			})
		})
	}

	return {
		init: init,
		name: 'faq-items'
	};
})();
